export const TITULO_AVISO_TWILIO_RH = 'Twilio RH'
export const PUESTOS_AVISO_TWILIO_RH = [11, 12, 68]
export const TIPO_SOCKET_HANDOFF_RH = 'twilio-rh-handoff'

export function esAvisoTwilioRh (noti) {
  return String((noti && noti.titulo) || '') === TITULO_AVISO_TWILIO_RH
}

export function extraerWa10AvisoRh (mensaje) {
  const m = String(mensaje || '').match(/\bWA\s+(\d{10})\b/)
  return m ? m[1] : ''
}

export function esPuestoAvisoTwilioRh (idpuesto) {
  return PUESTOS_AVISO_TWILIO_RH.indexOf(Number(idpuesto)) !== -1
}
